import { render } from "./BaoCaoThongKeTiemVacxin.vue?vue&type=template&id=22f92d80&ts=true"
import script from "./BaoCaoThongKeTiemVacxin.vue?vue&type=script&lang=ts"
export * from "./BaoCaoThongKeTiemVacxin.vue?vue&type=script&lang=ts"

import "./BaoCaoThongKeTiemVacxin.vue?vue&type=style&index=0&id=22f92d80&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/CDC/BaoCao/CDC_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__